import { legacy_createStore as createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as authSlice from "./AuthStore/authSlice";
import * as leaveSlice from "./LeaveStore/leaveSlice";
import * as userSlice from "./UserStore/userSlice";

export const authReducer = persistReducer(
  { storage, key: "state-auth", blacklist: [] },
  authSlice.Slice.reducer
);

export const leaveReducer = persistReducer(
  { storage, key: "state-leave", blacklist: [] },
  leaveSlice.Slice.reducer
);

export const userReducer = persistReducer(
  { storage, key: "state-user", blacklist: [] },
  userSlice.Slice.reducer
);

const userStore = createStore(userReducer);
const authStore = createStore(authReducer);
const leaveStore = createStore(leaveReducer);

persistStore(authStore);
persistStore(leaveStore);
persistStore(userStore);
